import script from "./DownloadGuidance.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadGuidance.vue?vue&type=script&setup=true&lang=js"

import "./DownloadGuidance.vue?vue&type=style&index=0&id=58ba74c8&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ba74c8"]])

export default __exports__